module.exports = __webpack_public_path__ + "img/apple-vision-pro.a57d7cc6.png";